// material-ui
import { Box, List, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { Route } from 'routes/RoutesTypes';
import { StateType } from 'store/reducers';
// project import
import NavItem from './NavItem';

// ==============================|| NAVIGATION - LIST GROUP ||============================== //

export interface NavGroupProps {
    group: Route;
    level?: number;
}

const NavGroup: React.FC<NavGroupProps> = ({ group, level = 0 }): JSX.Element => {
    const { title, children } = group;

    const menu = useSelector((state: StateType) => state.menu);
    const { drawerOpen } = menu;

    const items = children
        ?.filter((route) => route && route.title)
        .map((route: Route) =>
            route.path ? (
                <NavItem key={route.id} route={route} level={level + 1} />
            ) : (
                <NavGroup key={route.id} group={route} level={level + 1} />
            )
        );

    return (
        <List
            subheader={
                title &&
                drawerOpen && (
                    <Box sx={{ pl: 3, mb: 1.5 }}>
                        <Typography variant="subtitle2" color="textSecondary">
                            {title}
                        </Typography>
                    </Box>
                )
            }
            sx={{ mb: drawerOpen ? 1.5 : 0, py: 0, zIndex: 0 }}
        >
            {items}
        </List>
    );
};

export default NavGroup;
